import React, { useState, useEffect, Fragment, useRef } from "react";
import groupService from "../../../Group/services";
import service from "../service";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Pagination, PageHeader, paginate } from "../../../../Common";
import Joi from "@hapi/joi";
import { validateProperty, validate } from "../../../Common";
import { Grid } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import "react-datepicker/dist/react-datepicker.css";
import { routeEmployeeDetailsReportSchema } from "../routeEmployeeDetailsReportSchema";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import authService from "../../../Common/services";
import tokenService from "../../../../Common/tokenDecoder";
import "../../../Common/Table/table.css";
import MaterialTable from "material-table";
import Chip from "@material-ui/core/Chip";
import moment from "moment";
import xlsx from "json-as-xlsx";
import CreatePDF from "./createPdf";
import ReactToPrint from "react-to-print";

const screenCode = "ROUTEEMPLOYEEDETAILSREPORT";

export function RouteEmployeeDetailsReport(props) {
  const componentRef = useRef();

  const [groups, setGroups] = useState([]);
  const [operationEntity, setOperationEntity] = useState([]);
  const [collectionPoint, setCollectionPoint] = useState([]);
  const [collectionCategory, setCollectionCategory] = useState([]);
  const [isTableHide, setIsTableHide] = useState(true);
  const [searchData, setsearchData] = useState({
    groupID: "0",
    operationEntityID: "0",
    date: "",
  });
  const [errors, setErrors] = useState({});
  const schema = Joi.object(routeEmployeeDetailsReportSchema).options({
    allowUnknown: true,
  });
  const [data, setdata] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const DropdownChanges = Object.freeze({ group: 1, operationEntity: 2 });
  const [reportData, setReportData] = useState([]);
  const [isViewTable, setIsViewTable] = useState(true);
  const [total, setTotal] = useState(0);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const contentRowNames = [
    "collectionPointName",
    "collectionPointCode",
    "designationName",
    "firstName",
    "inTime",
    "outTime",
  ];
  const csvHeaders = [
    { label: "Route Name", value: "collectionPointName" },
    { label: "Route Code", value: "collectionPointCode" },
    { label: "Employee Type", value: "designationName" },
    { label: "Employee Name", value: "firstName" },
    { label: "IN", value: "inTime" },
    { label: "OUT", value: "outTime" },
  ];

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    group: "",
    estate: "",
    date: "",
  });

  useEffect(() => {
    trackPromise(getPermissions());
  }, []);

  useEffect(() => {
    trackPromise(getOperationEntities());
  }, [searchData.groupID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWROUTEEMPLOYEEDETAILSREPORT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );
    setPermissions({
      ...permissionList,

      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();
    setsearchData({
      ...searchData,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });

    getGroupsForDropDown();
  }

  async function getGroupsForDropDown() {
    const groupsList = await groupService.getGroupsForDropdown();
    setGroups(groupsList);
  }

  async function getOperationEntities() {
    const operationEntityList =
      await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
    setOperationEntity(operationEntityList);
  }

  function handleChange(e) {
    e.preventDefault();

    const target = e.target;
    const value = target.value;

    const error = { ...errors };
    const errorMessage = validateProperty(
      target,
      routeEmployeeDetailsReportSchema
    );
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setsearchData({
      ...searchData,
      [e.target.name]: value,
    });

    setErrors(error);
  }
  async function handleSearch(e) {
    const errorMessages = validate(schema, searchData);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    const reportData = await service.GetRouteEmployeeDetailsReport(
      searchData.operationEntityID,
      searchData.date
    );

    reportData.forEach((x) => {
      x.inTime =
        x.inTime === null
          ? "-"
          : moment(
              x.inTime.hours + ":" + x.inTime.minutes + ":" + x.inTime.seconds,
              "H:mm:ss"
            ).format("LT");
      x.outTime =
        x.outTime === null
          ? "-"
          : moment(
              x.outTime.hours +
                ":" +
                x.outTime.minutes +
                ":" +
                x.outTime.seconds,
              "H:mm:ss"
            ).format("LT");
    });

    setReportData(reportData);
    setCsvData(reportData);
    setIsViewTable(false);
    setSelectedSearchData();
  }

  function setSelectedSearchData() {
    setSelectedSearchValues({
      ...selectedSearchValues,
      group: groups[searchData.groupID],
      date: searchData.date,
    });
  }

  function checkDisbursement() {
    if (searchData.date === "") {
      setIsViewTable(true);
    } else {
      setIsViewTable(false);
    }
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function createFile() {
    var settings = {
      sheetName: "Route Employee Details Report",
      fileName: "Route Employee Details Report",
      writeOptions: {},
    };

    xlsx(csvHeaders, reportData, settings, true);
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="card">
          <div className="card-body" id="startPoint">
            <div className="row">
              <PageHeader title="Route Employee Details Report" />
            </div>
            <form>
              <div className="form-group row">
                <div className="col-md pb-1">
                  <InputLabel shrink id="groupID">
                    Group *
                  </InputLabel>
                  <Select
                    fullWidth
                    id="groupID"
                    name="groupID"
                    disabled={!permissionList.isGroupFilterEnabled}
                    value={searchData.groupID}
                    onChange={(e) => handleChange(e)}
                  >
                    <MenuItem value="0">--Select Group--</MenuItem>
                    {generateDropDownMenu(groups)}
                  </Select>
                  {errors["groupID"] && (
                    <FormHelperText
                      id="errbranchCode"
                      className="text text-danger"
                    >
                      {errors["groupID"]}
                    </FormHelperText>
                  )}
                </div>

                <div className="col-md pb-1">
                  <InputLabel shrink id="operationEntityID">
                    Factory *
                  </InputLabel>
                  <Select
                    fullWidth
                    id="operationEntityID"
                    name="operationEntityID"
                    disabled={!permissionList.isOperationEntityFilterEnabled}
                    value={searchData.operationEntityID}
                    onChange={(e) => handleChange(e)}
                  >
                    <MenuItem value="0">--Select Factory--</MenuItem>
                    {generateDropDownMenu(operationEntity)}
                  </Select>
                  {errors["operationEntityID"] && (
                    <FormHelperText
                      id="errbranchCode"
                      className="text text-danger"
                    >
                      {errors["operationEntityID"]}
                    </FormHelperText>
                  )}
                </div>

                <div className="col-md pb-1">
                  <TextField
                    id="date"
                    label="Date *"
                    name="date"
                    type="date"
                    fullWidth
                    value={searchData.date}
                    onChange={(e) => handleChange(e)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {errors["date"] && (
                    <FormHelperText
                      id="errbranchCode"
                      className="text text-danger"
                    >
                      {errors["date"]}
                    </FormHelperText>
                  )}
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md pb-1">
                  <input
                    type="button"
                    className="btn btn-primary"
                    value="Generate"
                    onClick={(e) => trackPromise(handleSearch(e))}
                  />
                </div>
              </div>
              <Grid item md={12} xs={12} hidden={isViewTable}>
                <MaterialTable
                  columns={[
                    { title: "Route Name", field: "collectionPointName" },
                    { title: "Route Code", field: "collectionPointCode" },
                    { title: "Employee Type", field: "designationName" },
                    { title: "Employee Name", field: "firstName" },
                    { title: "IN", field: "inTime", align: "left" },
                    { title: "OUT", field: "outTime", align: "left" },
                  ]}
                  data={reportData}
                  options={{
                    exportButton: false,
                    showTitle: false,
                    headerStyle: {
                      textAlign: "left",
                      height: "1%",
                      fontWeight: "bold",
                    },
                    columnResizable: false,
                  }}
                />
              </Grid>
            </form>
            {reportData.length == 0 ||
            reportData == undefined ||
            reportData == null ||
            reportData == [] ? null : (
              <div className="pt-3">
                <ReactToPrint
                  trigger={() => (
                    <input
                      type="button"
                      className="btn btn-primary pull-right ml-2"
                      value="Create PDF"
                    />
                  )}
                  content={() => componentRef.current}
                  documentTitle={"Route Employee Details Report"}
                />
                <div hidden={true}>
                  <CreatePDF
                    ref={componentRef}
                    data={csvData}
                    rowNames={contentRowNames}
                    searchData={selectedSearchValues}
                    total={total}
                  />
                </div>
                <input
                  type="button"
                  className="btn btn-primary pull-right ml-2"
                  value="Excel"
                  onClick={createFile}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
}
